import constant from "../constants/constants";

/**
 * This function is used to create local session
 * @param string _token
 */
export function setSession(_token, _refreshToken, _userId, user) {
    localStorage.setItem(constant.localStorageSessionKey, _token);
    _refreshToken && localStorage.setItem(constant.localStorageSessionRefreshTokenKey, _refreshToken);
    localStorage.setItem("_userToken", _userId);
    user?.projects.length > 0 ? localStorage.setItem('_user', JSON.stringify(user)) : clearSession();
}

/**
 * This function is used to get local session object
 * @returns object
 */
export function getSession() {
    return localStorage.getItem(constant.localStorageSessionKey);
}

/**
 * This function is used to remove local session object
 */
export function clearSession() {
    localStorage.removeItem(constant.localStorageSessionKey);
    localStorage.removeItem(constant.localStorageSessionRefreshTokenKey);
    localStorage.removeItem("_userToken");
    localStorage.removeItem('_user');
}